import { getTimezone } from "countries-and-timezones";

const detectTzCountry = (): string | undefined => {
  if (typeof window === "undefined" || typeof Intl === "undefined") return;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return getTimezone(tz)?.countries?.[0];
};

// NZ has no localized URL, so force en-AU translations (Multi, not Parlay).
export const shouldForceAuLocale = (): boolean => detectTzCountry() === "NZ";
